export default __webpack_public_path__ + "static/image-ba-coming-soon-444bbfc297a1cc8bb4990efed52ef789.png";